module.exports = __webpack_public_path__ + "static/fireplace-6a38a16aa9a1f91eb15a3dba48fb9216.svg";